import { UseFormReturn } from 'react-hook-form'
import { z } from 'zod'

import { FormField } from '@/components/form'
import { Label } from '@/components/label'

import { cn } from '@/utils/cn'

// eslint-disable-next-line react-refresh/only-export-components
export const sideSchema = z.object({
    side: z.enum(['Buy', 'Sell'] as const),
})
type SideSchemaType = z.infer<typeof sideSchema>

interface Props {
    form: UseFormReturn<SideSchemaType>
}

export default function CreateOrderSideForm({ form }: Props) {
    const value = form.watch('side')

    const className = 'px-4 py-2 mb-1 border-2 rounded-md cursor-pointer border-surface0 hover:border-primary'
    return (
        <div>
            <Label>Side</Label>
            <FormField
                control={form.control}
                name="side"
                render={({ field }) => {
                    const onSideChange = (side: SideSchemaType['side']) => {
                        field.onChange(side)
                    }

                    return (
                        <div className="grid grid-cols-3 gap-4 text-center">
                            <div
                                className={cn(className, {
                                    'border-primary': value === 'Buy',
                                })}
                                onClick={() => onSideChange('Buy')}
                            >
                                <p>Buy</p>
                            </div>
                            <div
                                className={cn(className, {
                                    'border-primary': value === 'Sell',
                                })}
                                onClick={() => onSideChange('Sell')}
                            >
                                <p>Sell</p>
                            </div>
                        </div>
                    )
                }}
            />
        </div>
    )
}
